'use client';

import { useEffect, useMemo, useState } from 'react';

import Image from 'next/image';

import { storageEdgeUrl } from '@/utils/constants';
import { AssetKey, getAssetUrls } from '@/utils/image-load-utils';

export default function ImageAsset(props: {
    ids: Array<string | null | undefined>;
    isAnimated?: boolean;
    quality?: number;
    assetKey: AssetKey;
    alt?: string;
    className?: string;
    priority?: boolean;
    isGallery?: boolean;
    filenameDisk?: string;
    objectFit?: 'cover' | 'contain';
}) {
    const assetUrls = useMemo(() => getAssetUrls(props.ids, props.assetKey), [props.ids, props.assetKey]);

    if (props.isAnimated && props.filenameDisk) {
        return (
            <Image
                src={`${storageEdgeUrl}/${props.filenameDisk}`}
                fill
                style={{ objectFit: props.objectFit || 'contain' }}
                sizes={'100vw, 33vw'}
                priority={props.priority ?? false}
                alt={props.alt || 'Image'}
                className={props.className}
            />
        );
    }

    if ('default' in assetUrls) {
        // eslint-disable-next-line @next/next/no-img-element
        return <img src={assetUrls.default} alt={props.alt || ''} className={props.className} />;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [imageSrc, setImageSrc] = useState<string>(assetUrls.prepared);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        props.isGallery && setImageSrc(assetUrls.prepared);
    }, [props.ids, props.isGallery, assetUrls.prepared]);

    return (
        <Image
            fill
            style={{ objectFit: props.objectFit || 'contain' }}
            quality={props.quality}
            sizes={'100vw, 33vw'}
            src={imageSrc}
            priority={props.priority ?? false}
            alt={props.alt || 'Image'}
            onError={(e) => {
                const target = e.target as HTMLImageElement;
                if (target.src !== assetUrls.onDemand) {
                    setImageSrc(assetUrls.onDemand);
                }
            }}
            className={props.className}
        />
    );
}
